/**
 * Browser detection utilities
 */

/**
 * Detects if the current browser is Safari
 * @returns true if running in Safari, false otherwise
 */
export function isSafari(): boolean {
  if (typeof window === "undefined") {
    return false; // Server-side
  }

  const userAgent = window.navigator.userAgent;

  // Safari detection: contains "Safari" but not "Chrome" or "Chromium"
  // This is necessary because Chrome also includes "Safari" in its user agent
  return (
    userAgent.includes("Safari") &&
    !userAgent.includes("Chrome") &&
    !userAgent.includes("Chromium")
  );
}

/**
 * Detects if the current browser is Chrome
 */
export function isChrome(): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  return window.navigator.userAgent.includes("Chrome");
}

/**
 * Detects if the current browser is Firefox
 */
export function isFirefox(): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  return window.navigator.userAgent.includes("Firefox");
}
